import { useMemo } from "react";
import classNames from "classnames";
import { useEffect } from "react";
import useGetRect from "../hooks/useGetRect";
import Icon from "./icon";
import Stepper from "./stepper";

const Title = ({
  children,
  handleNavigation = false,
  showStepper = false,
  stepper,
  description,
  button,
  handleSticky,
}) => {
  const { elemRef: parentRef, y } = useGetRect();
  const { elemRef, height } = useGetRect();

  useEffect(() => {
    if (handleSticky) {
      if (y < 0 && parentRef.current.style.marginBottom === "0px") {
        parentRef.current.style.marginBottom = `${height}px`;
      } else if (y >= 0 && parentRef.current.style.marginBottom !== "0px") {
        parentRef.current.style.marginBottom = 0;
      }
    }
  }, [parentRef, height, y, handleSticky]);

  const link = useMemo(() => button?.filter((item) => item.link), [button]);
  const cta = useMemo(() => button?.filter((item) => !item.link), [button]);
  const center = useMemo(() => cta?.some((button) => button.center), [cta]);

  return (
    <>
      <div className={classNames("app__title-placeholder")} ref={parentRef}>
        <div
          className={classNames(
            "app__title-wrapper dark-mode",
            handleSticky && y < 0 && "app__title-wrapper--clipped"
          )}
          ref={elemRef}
        >
          <div className="wrapper">
            <div className="app__header">
              <h1 className="app__title">
                {handleNavigation && (
                  <button onClick={handleNavigation} title="Back" aria-label="Back">
                    <Icon name="arrow" />
                  </button>
                )}
                <span>{children}</span>
              </h1>

              {description && (
                <div
                  className="app__description"
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                />
              )}
              {link?.map((item, i) => (
                <button
                  className={classNames(item?.className, item?.style || "link app__title-link")}
                  onClick={item?.action}
                  aria-label={item?.label}
                  key={i}
                >
                  <span>{item?.label}</span>
                  {item?.icon && <Icon name={item?.icon} />}
                </button>
              ))}
              {showStepper && stepper && (
                <Stepper
                  sections={stepper.sections}
                  currentSectionIndex={stepper.currentSectionIndex}
                  onClick={stepper.onClick}
                />
              )}
            </div>
            {cta?.length > 0 && (
              <div className={classNames("app__cta", center && "app__cta--center")}>
                {cta?.map((item, i) => (
                  <button
                    className={classNames(item?.className, item?.style || "primary")}
                    disabled={item?.disabled}
                    onClick={item?.action}
                    aria-label={item?.label}
                    key={i}
                  >
                    <span>{item?.label}</span>
                    {item?.icon && <Icon name={item?.icon} className={item?.icon} />}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Title;
